import React from 'react';
import MapView from '../components/MapView';

/**
 * Map Page - Displays the main map view
 * Receives drones and activeMissions from app-level state (no independent polling)
 */
function MapPage({ telemetry, dronesTelemetry, activeMissions, drones, sidebarVisible, onDroneSelect, selectedDroneId = null, isMobileLayout = false, topOffset = 0, currentUserRole = 'operator', isActive = true }) {
    return (
        <div style={{
            flex: 1,
            height: '100%',
            width: '100%',
            overflow: 'hidden',
            margin: 0,
            padding: 0,
            minHeight: 0
        }}>
            <MapView
                location={{ lat: telemetry.lat, lon: telemetry.lon }}
                dronesTelemetry={dronesTelemetry}
                activeMissions={activeMissions}
                drones={drones}
                sidebarVisible={sidebarVisible}
                onDroneSelect={onDroneSelect}
                selectedDroneId={selectedDroneId}
                isMobileLayout={isMobileLayout}
                topOffset={topOffset}
                currentUserRole={currentUserRole}
                isActive={isActive}
            />
        </div>
    );
}

export default MapPage;
